<template>
  <div v-loading="loading">
    <el-select
      v-model="field.selected_filter"
      @change="updateEntityData"
      clearable
      filterable
      :placeholder="fieldPlaceholder"
      :size="size == 'mini' ? 'mini' : 'large'"
      :multiple="isMultiple ? true : false"
      collapse-tags
    >
      <el-option
        v-for="(temp, i) in allEntityDataList"
        :key="temp._id + '_' + i"
        :value="temp._id"
        :label="getLabel(temp, i)"
        >{{ getLabel(temp, i) }}
      </el-option>
    </el-select>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  props: ["field", "fieldPlaceholder", "size", "isMultiple", "filters"],
  computed: {
    ...mapGetters("entities", [
      "getEntityDataByEntityId",
      "getEntityById",
      "getEntityRecordsForTable",
      "getEntitiesDataErrors",
    ]),
  },
  watch: {
    async field() {
      this.fetchEntityById(this.field.filter_field_entity_id);
    },
  },
  data() {
    return {
      currentEntity: null,
      loading: false,
      allEntityDataList: [],
    };
  },
  async mounted() {
    this.loading = true;
    await this.fetchEntityById(this.field.filter_field_entity_id);
    this.loading = false;
  },
  methods: {
    updateEntityData(value) {
      this.$emit("entityFilterUpdated", {
        entity_id: this.field.entity_id,
        value: value,
        filter: this.field,
      });
    },
    async fetchEntityById(entityId) {
      await this.$store.dispatch("entities/fetchEntityByIdForEntityField", {
        entity_id: entityId,
      });
      if (this.getEntityById) {
        this.currentEntity = this.getEntityById;
        this.fetchEntitiesDataForTable(entityId);
      } else {
        this.loading = false;
      }
    },
    async fetchEntitiesDataForTable(entityId) {
      this.loading = true;
      let params = {
        entity_id: entityId,
        template_fields_data: this.currentEntity.templates.map((template) => {
          return {
            template_id: template.template_id,
          };
        }),
        filters: this.filters || [],
      };
      await this.$store.dispatch("entities/fetchEntityRecordsForTable", params);
      if (this.getEntityRecordsForTable) {
        this.allEntityDataList = this.getEntityRecordsForTable.data;
        this.loading = false;
      } else {
        this.loading = false;
      }
    },
    getLabel(item, i) {
      let selectedEntity = this.currentEntity ? this.currentEntity : {};
      let name =
        item &&
        item.entity_prime_data &&
        Object.keys(item.entity_prime_data) &&
        item.entity_prime_data[Object.keys(item.entity_prime_data)[0]]
          ? item.entity_prime_data[Object.keys(item.entity_prime_data)[0]]
          : "data " + i;
      if (selectedEntity && selectedEntity.primaryFields) {
        let primaryField = selectedEntity.primaryFields[0];
        let key =
          primaryField && primaryField["key"] ? primaryField["key"] : null;
        if (key) {
          if (item.entity_prime_data && item.entity_prime_data[key]) {
            name = item.entity_prime_data[key];
          } else {
            name =
              item.entityData &&
              primaryField.template_id &&
              item.entityData[primaryField.template_id] &&
              item.entityData[primaryField.template_id][key]
                ? item.entityData[primaryField.template_id][key]
                : "data" + i;
          }
        }
      }
      return name;
    },
  },
};
</script>
